<template>
    <div :class="showDropzone && showUploadedFiles ? 'form-row' : mainDivCol + ' p-0'">
        <div v-if="showDropzone" class="form-group"
            :class="showDropzone && showUploadedFiles ? dropzoneCol : 'col-md-12 p-0'">
            <label v-if="dropzoneLabel" class="control-label mb-0" :class="dropzoneRequired ? 'require' : ''"
                id="upload_document">{{
                    dropzoneLabel }}</label>
            <section class="internal-container border-top-table-fl pt-0">
                <div class="custom-dropzone-container custom-photo-user-dropzone dropzone-margin">
                    <label class="control-label" for="documents">({{ acceptedFiles }} files are
                        allowed)</label>
                    <div id="app2">
                        <vue-dropzone :id="uniqueRef" :options="dropzoneOptions" :destroyDropzone="false"
                            :ref="uniqueRef" :headers="dropzoneOptions.headers" @vdropzone-success="storeDocument"
                            @vdropzone-removed-file="removedSelectedFile" @vdropzone-file-added="checkFileSize">
                        </vue-dropzone>
                        <div v-if="docErrorMsg" class="field-error">{{ docErrorMsg }}</div>
                        <div v-if="fileErrorMsg" class="field-error">{{ fileErrorMsg }}</div>
                    </div>
                    <label v-if="noteBelowDropzone" class="control-label" for="documents">{{ noteBelowDropzone }}
                    </label>
                </div>
            </section>
        </div>
        <div v-if="showUploadedFiles" :class="showDropzone && showUploadedFiles ? dropzoneFilesCol : 'col-md-12 p-0'">
            <div class="policy-attachment attachment-list-box">
                <label class="control-label" for="attachments">Uploaded Document</label>
                <template v-for="(uFile, fKey) in dropZonePreviewFiles">
                    <div v-bind:key="'fileDiv' + fKey" class="attachment-list no-translate">
                        <div class="d-flex align-items-center">
                            <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                            <i v-if="uFile.extension == 'doc' ||
                                uFile.extension == 'docs' ||
                                uFile.extension == 'docx'" class="fp-text-document"></i>
                            <i v-if="uFile.extension == 'jpg' ||
                                uFile.extension == 'png' ||
                                uFile.extension == 'jpeg' ||
                                uFile.extension == 'mp4' ||
                                uFile.extension == 'mkv'" class="fp-image"></i>
                            <a title="View File" class="mr-4" href="javascript:void(0)" v-on:click="
                                openDocument(uFile.url, uFile.extension)" v-bind:key="'fileName' + fKey">
                                {{ uFile["file_name"] }}
                            </a>
                        </div>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <button v-if="canRemoveUploadedFiles" title="Remove File" type="button"
                            v-bind:key="'cancelBtn' + fKey" v-on:click="
                                removeServerFile(uFile['file_name'], fKey)">
                            <i class="fp-close"></i>
                        </button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import { contractMixins } from "../mixins/contractMixins";
import { commonMixins } from "../mixins/commonMixins";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
    name: "DropZone",
    components: {
        vueDropzone: vue2Dropzone,
    },
    mixins: [commonMixins, contractMixins],
    props: {
        uniqueRef: {
            type: String,
            required: false,
            default: "documentDropzone"
        },
        showDropzone: {
            type: Boolean,
            required: false,
            default: true
        },
        showUploadedFiles: {
            type: Boolean,
            required: false,
            default: false
        },
        canRemoveUploadedFiles: {
            type: Boolean,
            required: false,
            default: true
        },
        maxFileLimit: {
            type: Number,
            required: false,
            default: 5
        },
        fileSizeLimit: {
            type: Number,
            required: false,
            default: 25
        },
        dropzoneLabel: {
            type: String,
            required: false,
            default: 'Upload Document'
        },
        dropzoneRequired: {
            type: Boolean,
            required: false,
            default: true
        },
        acceptedFiles: {
            type: String,
            required: false,
            default: ".jpg, .jpeg, .png, .pdf, .docx, .doc, .xlsx, .csv"
        },
        dropZonePreviewFiles: {
            type: Array,
            required: true,
            default: []
        },
        dropzoneCol: {
            type: String,
            required: false,
            default: 'col-md-5'
        },
        dropzoneFilesCol: {
            type: String,
            required: false,
            default: 'col-md-5'
        },
        docErrorMsg: {
            type: String,
            required: false,
            default: ''
        },
        noteBelowDropzone: {
            type: String,
            required: false,
            default: ''
        },
        isEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        needToCalculateMaxFile: {
            type: Boolean,
            required: false,
            default: false
        },
        mainDivCol: {
            type: String,
            required: false,
            default: 'col-md-5'
        }
    },
    data: () => ({
        files: [],
        fileErrorMsg: '',
        removedFiles: [],
        dropzoneOptions: {
            url: process.env.ROOT_API + "/upload-docs-to-temp",
            method: "POST",
            maxFilesize: 25.0, //MB
            timeout: 180000, // Timeout in milliseconds (e.g., 3 minutes)
            maxFiles: 1,
            thumbnailWidth: 150, // px
            thumbnailHeight: 150,
            createImageThumbnails: false,
            addRemoveLinks: true,
            duplicateCheck: true,
            acceptedFiles: ".jpg, .jpeg, .png, .pdf, .docx, .doc, .xlsx, .csv",
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.getItem("tkn"),
                "Access-Control-Allow-Headers":
                    "Origin, Content-Type, Authorization,X-Requested-With",
                "Cache-Control": "no-cache",
            },
            dictRemoveFileConfirmation: "Are you sure? You can't revert your action",
            destroyDropzone: false,
            dictDefaultMessage: "Drop file here to upload. Files up to 25 MB are allowed."
        },
    }),
    beforeMount() {
        this.dropzoneOptions.maxFiles = this.maxFileLimit;
        this.dropzoneOptions.maxFilesize = this.fileSizeLimit;
        this.dropzoneOptions.acceptedFiles = this.acceptedFiles;
        this.dropzoneOptions.dictDefaultMessage =
            "Drop file here to upload. Files up to " + this.fileSizeLimit + " MB are allowed.";
        if (this.needToCalculateMaxFile && this.isEdit) {
            this.dropzoneOptions.maxFiles = this.maxFileLimit - this.dropZonePreviewFiles.length;
        }
    },
    methods: {
        checkFileSize(file) {
            var self = this;
            self.fileErrorMsg = "";
            var maxAllowedSize = self.fileSizeLimit * 1024 * 1024; // Convert MB to bytes
            if (file.size >= maxAllowedSize) {
                self.fileErrorMsg = "The file size is too large. Please upload a file smaller than " + self.fileSizeLimit + "MB.";
                self.$refs[self.uniqueRef].removeFile(file);
                return;
            }
        },
        storeDocument(file, response) {
            var self = this;
            var uploadResponse = response.content;

            if (self.files.length > 0) {
                var idx = self.files.findIndex((obj) => obj == uploadResponse);
                if (idx == -1) {
                    self.files.push(uploadResponse);
                }
            } else {
                self.files.push(uploadResponse);
            }

            // Emit the updated files array to the parent component
            self.$emit('dropzone-update-files', self.files);
        },
        removedSelectedFile(file, xhr, error) {
            var self = this;
            if (file.status !== "error" && file.xhr) {
                const fileName = JSON.parse(file.xhr.response).content;
                const fileArr = fileName.split("/");

                self.removeFileFromServer(fileArr[1])
                    .then(() => {
                        const index = self.files.findIndex(f => f.includes(fileName));
                        if (index !== -1) {
                            self.files.splice(index, 1);
                        }
                    })
                    .catch(error => {
                        console.error("Error removing file from server:", error);
                    })
                    .finally(() => {
                        self.loading = false;
                    });
            }
        },
        removeServerFile(fileName, key) {
            var self = this;
            if (confirm('Are you sure that you want to remove file? ')) {
                self.dropZonePreviewFiles.splice(key, 1);
                if (!self.isEdit) {
                    self.removeFileFromServer(fileName);
                } else {
                    self.removedFiles.push(fileName);
                    // Emit the updated removedFiles array to the parent component
                    self.$emit('dropzone-remove-files', self.removedFiles);
                    if (self.needToCalculateMaxFile && self.isEdit) {
                        // Adjust maxFiles based on the files removed
                        const newMaxFiles = Math.min(this.maxFileLimit, this.dropzoneOptions.maxFiles + 1);
                        this.dropzoneOptions.maxFiles = newMaxFiles;
                        this.$nextTick(() => {
                            const dropzoneInstance = this.$refs[this.uniqueRef];
                            if (dropzoneInstance.dropzone) {
                                // Use .setOption() to update the Dropzone maxFiles option
                                dropzoneInstance.setOption('maxFiles', newMaxFiles);
                            }
                        });
                    }
                }

                //remove file from files array
                for (var i = 0; i < self.files.length; i++) {
                    if (self.files[i].includes(fileName)) {
                        self.files.splice(i, 1);
                    }
                }
            }
        },
        removeFileFromServer(file) {
            var self = this;
            self.loading = true;
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: process.env.ROOT_API + "/remove-docs-from-temp",
                    type: "POST",
                    data: {
                        filePath: file,
                    },
                    headers: self.ajxHeaders,
                    dataType: "json",
                    success: data => {
                        resolve(data);
                        self.loading = false;
                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                        reject(errorThrown);
                    }
                });
            });
        },
    }
}
</script>
<style scoped>
.attachment-list {
    display: flex;
    align-items: center;
    gap: 8px;
    /* Optional: Adds spacing between elements */
    word-break: break-word;
    /* Ensures long words wrap */
    overflow-wrap: break-word;
    /* Alternative for better compatibility */
    max-width: 100%;
    /* Ensures it respects parent width */
    justify-content: space-between;
}

.attachment-list a {
    display: block;
    /* Forces the link to behave as a block element */
    white-space: normal;
    /* Ensures text wraps */
    word-break: break-word;
    overflow-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/DropZone.vue